import React, { useState } from "react";

type ProgressiveImageProps = {
  lowSrc: string;
  highSrc: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  mode?: "absolute" | "relative"; 
};

const ProgressiveImage: React.FC<ProgressiveImageProps> = React.memo(({
  lowSrc,
  highSrc,
  alt = "",
  className = "",
  style = {},
  mode = "relative", // default to relative for standalone
}) => {
  const [loaded, setLoaded] = useState(false);

  if (mode === "absolute") {
    // For carousels: parent must have fixed height!
    return (
      <div
        className={className}
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "hidden",
          borderRadius: "20px",
          display: "block",
          flex: "1 1 100%",
          backgroundImage: `url(${lowSrc})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          ...style,
        }}
      >
        <img
          src={highSrc}
          alt={alt}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center center",
            display: "block",
            opacity: loaded ? 1 : 0,
            transition: "opacity 0.35s ease",
          }}
          onLoad={() => setLoaded(true)}
          loading="eager"
          decoding="async"
          draggable={false}
        />
      </div>
    );
  }

  // "relative" mode: for standalone images, height adjusts dynamically
  return (
    <div
      className={className}
      style={{
        position: "relative",
        width: "100%",
        ...style,
      }}
    >
      <img
        src={lowSrc}
        // srcSet={`${lowSrc} 1x`}
        // sizes="100vw"
        alt={alt}
        style={{
          filter: "blur(12px)",
          transition: "opacity 0.5s",
          opacity: loaded ? 0 : 1,
          width: "100%",
          height: "auto",
          objectFit: "cover",
          borderRadius: "20px",
          position: "absolute",
          top: 0,
          left: 0,
        }}
        draggable={false}
      />
      <img
        src={highSrc}
        // srcSet={`${highSrc} 1x, ${highSrc} 2x`}
        // sizes="100vw"
        alt={alt}
        style={{
          transition: "opacity 0.5s",
          opacity: loaded ? 1 : 0,
          width: "100%",
          height: "auto",
          objectFit: "cover",
          borderRadius: "20px",
          display: "block",
          position: "relative", // This image sets the container height
          zIndex: 1,
        }}
        onLoad={() => setLoaded(true)}
        draggable={false}
      />
    </div>
  );
});

export default ProgressiveImage;